export * from './config-lang';

export { default as useLocales } from './use-locales';

export { default as LocalizationProvider } from './localization-provider';
